import type { FaireProductEntity } from "../../entity_types/product";

export const p_jmmyb77cjn: FaireProductEntity = {
  token: "p_jmmyb77cjn",
  type: "product",
  name: "Coco Rose Earl Grey - Wholesale",
  brandToken: "b_7piiqmq04r",
  brandName: "Lake & Oak Tea Co.",
  imageUrl: "https://cdn.faire.com/fastly/0f2494be021cda2257fee26ccd21fa152418268f0755336dd78575247101f700.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/78b7b841da0c35d43879082c916765919709c8b90e13b4cba7152b11af7c23e2.jpeg",
    "https://cdn.faire.com/fastly/39bd178df219c7bc43164707bbb570484c5f0027d0f6c9617927d3058ab6b669.jpeg",
    "https://cdn.faire.com/fastly/d0d3e48b02acab9a87a8dbf98598130118c008e2c64b8de19a774e4a5880c33a.png"
  ],
  priceDollars: 58,
  description: "SUPERFOOD TEA BLEND\n\nThis luxurious twist on the classic Earl Grey is light and balanced with organic bergamot essence and a hit of nuttiness from toasted coconut. Blended with rose petals and cinnamon, it will transform your daily cup of tea into a goddess-worthy ritual.\n\n100% ORGANIC - NUTRITIONIST FORMULATED \n\n How to Enjoy:\n\n * Steep tea in 1 cup of 98° water for 4-6 minutes. \n * Try me with a splash of milk and honey. \n * Tea Latte: Steep tea double strength and top with frothed milk, vanilla and sweetener. \nWhen to Steep:\n\n\n * During your morning ritual \n * With your breakfast in the morning \n * 2pm pick-me-up \n * Instead of your morning coffee \nModerate Caffeine\n",
  tags: [],
  msrpDollars: 116,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:42.376Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
